<ng-container *ngFor="let column of budgetColumns">

  <div *ngIf="isBudgetAnchorForecast && ((budgetColumnsVisibility[column.id] && column.id === budgetColumnName.Budget) || (budgetColumnsVisibility[column.id] && (totalsSidebarState === sidebarState.FullWidth)) || (budgetColumnsVisibility[column.id] && (budgetColumnName.Forecast === column.id)))">
    <div class="segment-breakdown" *ngIf="recordTotals">
      <div class="sub-row-item" [class.p-0]="column.id === budgetColumnName.Budget" [ngClass]="{ 'forecast-total-value-cell': column.id === budgetColumnName.Forecast, 'is-disabled': record.isClosed, 'budget-anchor': isBudgetAnchorForecast }">
        <budget-allocation-cell
          *ngIf="column.id === budgetColumnName.Forecast; else totalValue"
          [allocated]="recordTotals[column.id].ownAmount"
          [remaining]="recordTotals[budgetColumnName.Available].ownAmount"
          [disabled]="isClosed"
          [showDifference]="showDifference"
        >
        </budget-allocation-cell>
        <ng-template #totalValue>
          <budget-allocation-cell
            *ngIf="column.id === budgetColumnName.Budget"
            [allocated]="recordTotals[column.id].ownAmount"
            [remaining]="false"
            [disabled]="isClosed"
            [showDifference]="false"
          ></budget-allocation-cell>
          <span *ngIf="column.id !== budgetColumnName.Budget">{{ recordTotals[column.id].ownAmount | absoluteNumber }}</span>
        </ng-template>
      </div>
      <ng-container *ngIf="segmentRelated">
        <div class="sub-row-item"
         [ngClass]="{ 'forecast-total-value-cell': column.id === budgetColumnName.Forecast, 'is-disabled': record.isClosed }"
        *ngIf="segmentBreakdownConfig.campaignsAndPrograms">
              {{ recordTotals[column.id].campaignsAndPrograms | absoluteNumber }}
        </div>
        <div class="sub-row-item"
         *ngIf="segmentBreakdownConfig.unallocated"
         [ngClass]="{ 'forecast-total-value-cell': column.id === budgetColumnName.Forecast, 'is-disabled': record.isClosed }"
         >         
            {{ recordTotals[column.id].unallocated | absoluteNumber }}
      </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="!isBudgetAnchorForecast && ((column.id === budgetColumnName.Budget) || (budgetColumnsVisibility[column.id] && totalsSidebarState === sidebarState.FullWidth) || (budgetColumnsVisibility[column.id] && budgetColumnName.Forecast === column.id))">
    <div class="segment-breakdown" *ngIf="recordTotals">
      <div class="sub-row-item" [class.p-0]="column.id === budgetColumnName.Budget" [ngClass]="{ 'forecast-total-value-cell': column.id === budgetColumnName.Forecast, 'is-disabled': record.isClosed }">
        <budget-allocation-cell
          *ngIf="column.id === budgetColumnName.Budget; else totalValue"
          [allocated]="recordTotals[column.id].ownAmount"
          [remaining]="recordTotals[budgetColumnName.Available].ownAmount"
          [disabled]="isClosed"
          [showDifference]="showDifference"
        >
        </budget-allocation-cell>
        <ng-template #totalValue>
          {{ recordTotals[column.id].ownAmount | absoluteNumber }}
        </ng-template>
      </div>
      <ng-container *ngIf="segmentRelated">
        <div class="sub-row-item"
         [ngClass]="{ 'forecast-total-value-cell': column.id === budgetColumnName.Forecast, 'is-disabled': record.isClosed }"
        *ngIf="segmentBreakdownConfig.campaignsAndPrograms">
              {{ recordTotals[column.id].campaignsAndPrograms | absoluteNumber }}
        </div>
        <div class="sub-row-item"
         *ngIf="segmentBreakdownConfig.unallocated"
         [ngClass]="{ 'forecast-total-value-cell': column.id === budgetColumnName.Forecast, 'is-disabled': record.isClosed }"
         >         
            {{ recordTotals[column.id].unallocated | absoluteNumber }}
      </div>
      </ng-container>
    </div>
  </div>
</ng-container>
